import { createFileRoute } from '@tanstack/react-router';

import { RegisterPage } from '../auth/register-page';
import { useAppNavigate } from '../lib/session/navigate';
import { DEFAULT_NEXT_PATH, safeNextPath } from '../lib/session/next-path';

/** `/register?next=/account` — create a patient account (FR-PORTAL-01). */

interface RegisterSearch {
  next?: string;
}

export const Route = createFileRoute('/register')({
  validateSearch: (search: Record<string, unknown>): RegisterSearch =>
    typeof search['next'] === 'string'
      ? { next: safeNextPath(search['next'], DEFAULT_NEXT_PATH) }
      : {},
  component: RegisterRoute,
});

function RegisterRoute() {
  const { next } = Route.useSearch();
  const navigate = useAppNavigate();

  return (
    <RegisterPage
      onRegistered={() => {
        navigate(next ?? DEFAULT_NEXT_PATH, { replace: true });
      }}
      onNavigate={navigate}
    />
  );
}
